{#if filterArray.length}
    <div class="my-8 border bg-gray-50 px-5 rounded">
        {#each filterArray as filterObject, i}
            {#if i > 0}
                <div class="relative">
                    <hr class="border-gray-200 absolute top-1/2 left-0 w-full z-0">
                    <svg class="fill-gray-300 bg-white rounded-full z-10 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"/>
                    </svg>
                </div>
            {/if}
            <FilterItem filterObject={filterObject}
                        config={config}
                        on:removeFilter
                        on:updateFilter
            />
        {/each}
    </div>
{/if}

<button class="py-2 px-4 bg-green-drkn text-white rounded shadow focus:outline-none flex hover:bg-lime-500 transition"
        on:click={onAddFilter}>
    <svg class="scale-75 fill-white mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"/>
    </svg>
    Filter hinzufügen
</button>


<script>
    import FilterItem from "./filter-item.svelte";
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    export let filterArray;

    export let config;

    function onAddFilter() {
        dispatch("addFilter");
    }
</script>